import { Box, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router'
import { BrokenLinkIcon } from '../../components/icons'

export const RedirectError = () => {
  const navigate = useNavigate()
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
      <Typography variant="h3">We can't find that page</Typography>
      <Typography variant="h6" sx={{ fontWeight: 400 }}>
        It might have been moved, renamed, or never existed.
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <BrokenLinkIcon sx={{ fontSize: '128px', my: '2rem' }} />
        <Typography variant="h6" sx={{ fontWeight: 400, my: '1rem' }}>
          Let's get you where you need to go.
        </Typography>
        <Button
          variant="contained"
          onClick={() => {
            navigate('/')
          }}
        >
          Take me home
        </Button>
      </Box>
    </Box>
  )
}
